<template>
  <div class="form-page">
    <div class="header-img-wrapper">
      <img src="../assets/01-BANNER-FBC25.png" class="header-img" alt="Formulario de Registro" />
    </div>
    <div class="container p-3 p-sm-4">
      <RegistroForm />
    </div>
  </div>
</template>

<script setup>
import RegistroForm from '../components/RegistroForm.vue'
</script>

<style scoped>
* {
  font-family: "ColgateReady-Regular";
}

.form-page {
  margin: 0;
  padding: 0;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.header-img-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 0;
}

.header-img {
  width: 100%;
  height: auto;
  max-height: 220px;
  object-fit: contain;
}

.container {
  max-width: 720px;
  margin: 0 auto;
  padding: 1rem;
}

@media (min-width: 768px) {
  .header-img {
    max-width: 700px;
    max-height: 200px;
  }
  .container {
    padding: 2rem;
  }
}

@media (min-width: 1024px) {
  .header-img {
    max-width: 800px;
    max-height: 220px;
  }
  .container {
    padding: 2.5rem;
  }
}
</style>
